import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useEcommerceContext } from '@blaze-cms/ecommerce-context';
import { GET_PRODUCT_VARIANTS_QUERY } from '../../services';
import { CONTEXT_KEYS } from '../constants';
import Variant from './Variant';
import { addModifier, addPublishedEntityPrefix } from '../helpers';
import { DEFAULT_NOT_AVAILABLE_MESSAGE, VARIANTS_CLASSNAME } from './constants';

const Variants = ({ parent, modifier, notAvailableMessage }) => {
  const { itemEntity: parentEntity, itemId: parentId } = parent;
  const { currency, variant, setContextState } = useEcommerceContext();
  const { variantKey } = CONTEXT_KEYS;
  const { data: { productVariants } = {}, error } = useQuery(GET_PRODUCT_VARIANTS_QUERY, {
    variables: {
      id: parentId,
      entityIdentifier: addPublishedEntityPrefix(parentEntity),
      currency
    },
    skip: !parentId && !parentEntity
  });

  const handleVariantSelect = variantId => {
    setContextState(variantKey, variantId);
  };
  const variantsClassName = addModifier(VARIANTS_CLASSNAME, modifier);
  if (error) return <>{error.message}</>;
  if (!productVariants || !productVariants.length)
    return (
      <div className={variantsClassName}>
        <div className="blaze-ecommerce-variants-not-available-message">
          {notAvailableMessage || DEFAULT_NOT_AVAILABLE_MESSAGE}
        </div>
      </div>
    );

  const selectedVariant = variant || productVariants[0].variantId;
  const { stockLabel } =
    productVariants.find(({ variantId }) => variantId === selectedVariant) || {};

  return (
    <>
      {stockLabel && <div className="blaze-ecommerce-variants-stock-label">{stockLabel}</div>}
      <div className={variantsClassName} role="radiogroup">
        {productVariants.map(({ variantId, name, price }) => (
          <Variant
            key={variantId}
            variantId={variantId}
            price={price}
            name={name}
            selectedVariant={selectedVariant}
            handleVariantSelect={handleVariantSelect}
            className={VARIANTS_CLASSNAME}
          />
        ))}
      </div>
    </>
  );
};

Variants.propTypes = {
  parent: PropTypes.object.isRequired,
  modifier: PropTypes.string,
  notAvailableMessage: PropTypes.string
};

Variants.defaultProps = { modifier: '', notAvailableMessage: '' };

export default Variants;
